import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DimensionsUnitsEnum } from 'src/app/core/enums/dimensions-units.enum';
import convertDimensions from 'src/app/core/helpers/dimensions-weight';
import { LocationSize } from 'src/app/location/models/location-size.interface';

@Component({
  selector: 'app-create-location-size-modal',
  templateUrl: './create-location-size-modal.component.html',
})
export class CreateLocationSizeModalComponent implements OnInit {
  @Output() onApprove = new EventEmitter<LocationSize>();

  form: FormGroup = this.fb.group({
    name: ['', Validators.required],
    width: ['', Validators.required],
    length: ['', Validators.required],
    height: ['', Validators.required],
  });

  constructor(
    public dialogRef: MatDialogRef<CreateLocationSizeModalComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: LocationSize,
  ) {}

  ngOnInit() {
    if (this.data) {
      const { width, length, height } = this.data;
      this.form.patchValue({
        name: this.data.name,
        width: convertDimensions(width, DimensionsUnitsEnum.MM, DimensionsUnitsEnum.CM),
        length: convertDimensions(length, DimensionsUnitsEnum.MM, DimensionsUnitsEnum.CM),
        height: convertDimensions(height, DimensionsUnitsEnum.MM, DimensionsUnitsEnum.CM),
      });
    }
  }

  approve(): void {
    if (this.form.valid) {
      const payload: any = {
        ...this.form.value,
        width: convertDimensions(this.form.value.width, DimensionsUnitsEnum.CM, DimensionsUnitsEnum.MM),
        length: convertDimensions(this.form.value.length, DimensionsUnitsEnum.CM, DimensionsUnitsEnum.MM),
        height: convertDimensions(this.form.value.height, DimensionsUnitsEnum.CM, DimensionsUnitsEnum.MM),
      };

      this.onApprove.emit(payload);
      this.dialogRef.close();
    }
  }

  reject(): void {
    this.dialogRef.close();
  }
}
